<template>
  <div class="bg">
    <div class="ordermartop">
      <van-tabs v-model="active" sticky animated @click="onClick">
        <van-tab v-for="(item,index) in navArr" :key="index" :title="item">
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh" >
            <!-- 下拉刷新 -->
            <van-list
              v-model="loading"
              :finished="finished"
              loading-text="正在加载中..."
              :error.sync="error"
              finished-text="没有更多了"
              error-text="请求失败，请您检查登陆状态，点击重新加载"
              @load="onLoad"
            >
              <!-- 上拉加载 -->
              <ul class="order_list">
                <li class="order_item" v-for="(item,index) in dataList" :key="index">
                  <div class="order_sn">
                    <p>订单编号：{{item.orderSn}}</p>
                    <div class="order_status">
                      <template v-if="item.afterStatus == 0">
                        <template v-if="item.status == 0">待付款</template>
                        <template v-if="item.status == 1">待发货</template>
                        <template v-if="item.status == 2">待收货</template>
                        <template v-if="item.status == 3">待评价</template>
                        <template v-if="item.status == 4">已完成</template>
                        <template v-if="item.status == 5">已取消</template>
                        <template v-if="item.status == 6">已关闭</template>
                      </template>
                      <template v-if="item.afterStatus == 1">退款中</template>
                      <template v-if="item.afterStatus == 2">退款成功</template>
                      <template v-if="item.afterStatus == 3">
                        <template v-if="item.status == 0">待付款</template>
                        <template v-if="item.status == 1">待发货</template>
                        <template v-if="item.status == 2">待收货</template>
                        <template v-if="item.status == 3">待评价</template>
                        <template v-if="item.status == 4">已完成</template>
                        <template v-if="item.status == 5">已取消</template>
                        <template v-if="item.status == 6">已关闭</template>
                      </template>
                      <template v-if="item.afterStatus == 4">
                        <template v-if="item.status == 0">待付款</template>
                        <template v-if="item.status == 1">待发货</template>
                        <template v-if="item.status == 2">待收货</template>
                        <template v-if="item.status == 3">待评价</template>
                        <template v-if="item.status == 4">已完成</template>
                        <template v-if="item.status == 5">已取消</template>
                        <template v-if="item.status == 6">已关闭</template>
                      </template>
                    </div>
                  </div>
                  <!-- 商品明细 -->
                  <div class="shop_detail">
                    <div
                      class="detail"
                      v-for="(goods,indes) in item.orderItemList"
                      :key="indes"
                      @click="onDetail(item.id)"
                    >
                      <div
                        :class="item.orderItemList.length > 1 ? 'active image' : 'image'"
                        v-if="indes < 3"
                      >
                        <img :src="goods.productPic" />
                      </div>
                      <div class="right" v-if="item.orderItemList.length == 1">
                        <div class="box">
                          <div class="text_1">
                            <div class="autark" v-if="item.supplierCode === 'ZY'">自营</div>
                            <div class="abroad" v-if="goods.houniaoAbroadStatus === 1">海外</div>
                            {{goods.productName}}
                          </div>
                          <div class="text_2">{{goods.productAttr}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- 共：{{item.productNum}}件，合计： -->
                  <div class="total">应付: ￥{{item.payAmount}}</div>
                  <div class="button_count">
                    <div class="button">
                      <van-button
                      type="default"
                      plain
                      v-if="item.status > 1 && item.status < 5"
                      @click="orderCourier(item.deliverySn, item.deliveryCompany)"
                      class="custom"
                    >查看物流</van-button>
                      <van-button
                        type="danger"
                        plain
                        v-if="item.status == 0"
                        @click="orderPay(item.id,item.payAmount,item.autoCancelTime,item)"
                        class="custom"
                      >付款</van-button>
                      <van-button
                        type="default"
                        plain
                        v-if="item.status == 0"
                        @click="orderCancel(item.id)"
                        class="custom"
                      >取消订单</van-button>
                      <template v-if="item.afterStatus != 1 && item.afterStatus != 2">
                        <!-- 退款 -->
                        <van-button
                          type="default"
                          plain
                          v-if="item.status == 1"
                          @click="orderOnego(item)"
                          class="custom"
                        >申请退款</van-button>
                        <van-button
                          type="default"
                          plain
                          v-if="item.status == 2"
                          @click="orderSure(item.id)"
                          class="custom"
                        >确认收货</van-button>
                      </template>
                      <van-button
                        type="default"
                        plain
                        v-if="item.status === 4"
                        @click="orderdelete(item.id,index)"
                        class="custom"
                      >删除订单</van-button>
                      <van-button
                        type="default"
                        plain
                        v-else-if="item.status === 5"
                        @click="orderdelete(item.id,index)"
                        class="custom"
                      >删除订单</van-button>
                      <van-button
                        type="default"
                        plain
                        v-else-if="item.status === 6"
                        @click="orderdelete(item.id,index)"
                        class="custom"
                      >删除订单</van-button>
                      <van-button
                        type="default"
                        plain
                        v-else-if="item.afterStatus === 1"
                        @click="orderSpeed(item)"
                        class="customborderred"
                      >售后中</van-button>
                      <van-button
                        type="default"
                        plain
                        v-else-if="item.afterStatus === 2"
                        @click="orderSpeed(item)"
                        class="customborderred"
                      >售后已通过</van-button>
                      <van-button
                        type="default"
                        plain
                        v-else-if="item.afterStatus === 3"
                        @click="orderSpeed(item)"
                        class="customborderred"
                      >售后已拒绝</van-button>
                      <van-button
                        type="default"
                        plain
                        v-else-if="item.afterStatus === 4"
                        @click="orderSpeed(item)"
                        class="customborderred"
                      >售后完毕</van-button>
                    </div>
                    <div class="count_down" v-if="item.status == 0">本订单将于{{item.autoCancelTime}}关闭</div>
                  </div>
                </li>
              </ul>
            </van-list>
          </van-pull-refresh>
        </van-tab>
      </van-tabs>
    </div>
    <div style="margin-top:50px;">
      <van-empty
        v-if="dataList.length<1"
        class="custom-image"
        :image="normal"
        description="还没有相关订单呢"
      />
    </div>
  </div>
</template>

<script>
import { Tab, Tabs, List, PullRefresh, Image, Button, Dialog, Toast, Empty } from 'vant'
import { orderList, orderCancel, orderReceive, orderdelete } from '../../request/api.js'
export default {
  name: 'orderList',
  components: {
    [Image.name]: Image,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [List.name]: List,
    [Toast.name]: Toast,
    [PullRefresh.name]: PullRefresh,
    [Button.name]: Button,
    [Empty.name]: Empty
  },
  data () {
    return {
      active: 0,
      navArr: ['全部', '待付款', '待发货', '待收货', '待评价'],
      error: false,
      normal: require('@/assets/orderlist.png'),
      dataList: [], // 请求数据
      loading: false, // 上拉加载
      finished: false, // 上拉加载完毕
      isLoading: false, // 下拉刷新
      pageNum: 1 // 页码
    }
  },
  created () {
    this.isFirstEnter = true
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
      loadingType: 'spinner'
    })
    this.pageNum = 1
    this.dataList = []
    console.log('created')
  },
  methods: {
    async onClick (e) {
      console.log(e)
      this.dataList = []
      var _this = this
      this.pageNum = 1
      var params
      if (e === 0) {
        params = {
          order: 1,
          pageSize: 12,
          pageNum: 1
        }
      } else {
        params = {
          status: e - 1,
          order: 1,
          pageSize: 12,
          pageNum: 1
        }
      }
      console.log(params)
      const res = await orderList(params)
      console.log(res)
      if (res.code === 200) {
        this.dataList = res.data.list
        Toast.clear()
        if (res.data.list.length === 0) {
          _this.finished = true
          console.log(11111)
        } else if (res.data.list.length < 5) {
          this.loading = false
        }
      }
    },
    orderOnego(i) {
      console.log(i)
      var orderlist = JSON.stringify(i)
      this.$router.push({ path: '/refund', query: { orderlistdata: orderlist } })
    },
    onLoad () {
      this.pageNum += 1
      console.log(this.pageNum)
      var params
      if (this.active === 0) {
        params = {
          order: 1,
          pageSize: 12,
          pageNum: this.pageNum
        }
      } else {
        params = {
          status: this.active - 1,
          order: 1,
          pageSize: 12,
          pageNum: this.pageNum
        }
      }
      console.log(params)
      orderList(params)
        .then(res => {
          console.log(res)
          if (res.code === 200) {
            setTimeout(() => {
              console.log(res.data)
              this.dataList = this.dataList.concat(res.data.list)
              this.loading = false
              if (this.dataList.length >= res.data.total) {
                this.finished = true
                console.log('到底了')
              }
            }, 1000)
          } else {
            this.loading = false
            this.error = true
          }
        })
        .catch(res => {
          console.log(res)
        })
    },
    onRefresh () {
      setTimeout(() => {
        Toast.clear()
        // this.dataList = []
        console.log('下拉刷新')
        // 清空列表数据
        this.finished = false
        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.isLoading = false
        this.onLoad()
      }, 1000)
    },
    // 售后中
    orderSpeed(i) {
      console.log(i)
      this.$router.push({ path: '/Speed', query: { id: i.returnId, MultiCommodity: 2 } })
    },
    onDetail (id) {
      console.log(id)
      this.$router.push(`/orderInfo/${id}`)
    },
    // 支付
    orderPay (id, money, time, i) {
      console.log(i)
      var data = JSON.parse(sessionStorage.getItem('pay'))
      console.log(data)
      var pay = JSON.stringify({ id: id, money: money, time: time, address: { addrNameFull: i.receiverAddrNameFull, detailAddress: i.receiverDetailAddress, name: i.receiverName, phone: i.receiverPhone } })
      sessionStorage.setItem('pay', pay)
      this.$router.push({ path: '/pay' })
    },
    // 评价
    orderEval (i, id) {
      console.log(i, id)
      // 跳转路由传递对象参数
      var arr = JSON.stringify(i)
      this.$router.push({ path: '/CommodityEvaluation', query: { content: arr, id: id } })
    },
    // 取消订单
    orderCancel (id) {
      var _this = this
      console.log(this.active)
      Dialog.confirm({
        message: '是否取消订单'
      })
        .then(() => {
          orderCancel(id, { id: id }).then(res => {
            console.log(res)
            if (res.code === 200) {
              this.$router.go(0)
              _this.pageNum = 0
              if (_this.active === 0) {
                _this.onClick(_this.active)
              } else if (_this.active === 1) {
                _this.onClick(_this.active)
              }
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    // 删除订单
    orderdelete (id, index) {
      console.log(index)
      // var _this = this
      Dialog.confirm({
        message: '是否删除该订单'
      })
        .then(() => {
          orderdelete(id, { id: id }).then(res => {
            console.log(res)
            if (res.code === 200) {
              this.dataList.splice(index, 1)
              Toast.success(res.message)
            } else {
              Toast.fail(res.message)
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    // 申请售后
    orderSale() {
      this.$router.push('/afterSale')
    },
    // 确认收货
    orderSure (id) {
      var _this = this
      console.log(this.active)
      Dialog.confirm({
        message: '是否确认收货'
      })
        .then(() => {
          orderReceive(id, { id: id }).then(res => {
            console.log(res)
            if (res.code === 200) {
              _this.pageNum = 0
              if (_this.active === 0) {
                _this.onClick(_this.active)
              } else if (_this.active === 3) {
                _this.onClick(_this.active)
              }
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    // 物流
    orderCourier (sn, cm) {
      this.$router.push({ path: '/orderCourier', query: { sn: sn, cm: cm } })
    }
  },
  activated() {
    if (!this.$route.meta.isBack || this.isFirstEnter) {
      console.log('activated')

      // 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
      // 如果isFirstEnter是true，表明是第一次进入此页面或用户刷新了页面，需获取新数据
      this.active = 0
      this.dataList = [] // 把数据清空，可以稍微避免让用户看到之前缓存的数据
      this.pageNum = 0
      console.log(this.pageNum)
      this.onClick(0)
    }
    // 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
    this.$route.meta.isBack = false
    // // 恢复成默认的false，避免isBack一直是true，导致每次都获取新数据
    this.isFirstEnter = false
  },
  beforeRouteEnter(to, from, next) {
    console.log(to, from)
    if (from.name === 'orderInfo') {
      to.meta.isBack = true
    } else if (from.name === 'Speed') {
      to.meta.isBack = true
    } else if (from.name === 'afterrecords') {
      to.meta.isBack = true
    }
    next()
  }
}
</script>

<style lang="less" scoped>
@pierce: ~">>>";
@widthframe: 690px;
* {
  box-sizing: border-box;
}
.bg {
  background: #f2f2f2;
  min-height: 100vh;
}
/deep/ .van-sticky {
  height: 100px;
}
/deep/ .van-tabs--line .van-tabs__wrap {
  height: 90px;
  border: 0.2px solid #f2f2f2; /*no*/
  border-bottom: 1px solid #f2f2f2; /*no*/
}
/deep/ .van-tab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-basis: 20% !important;
  font-size:28px ;
}
/deep/ .van-pull-refresh{
  min-height: 100vh;
}
/deep/ .van-pull-refresh__track{
  min-height: 100vh;
}
.order_list {
  width: 100%;
  overflow: hidden;
}
/* 订单列表渲染 */
.order_list .order_item {
  width: 100%;
  padding-left: 32px;
  margin: 20px 0 0;
  background: #fff;
  overflow: hidden;
  position: relative;
}
.order_list .order_item .order_sn {
  float: left;
  width: 100%;
  color: #333;
  font-size: 28px;
  line-height: 1;
  padding: 24px 0 30px;
  border-bottom: 1px solid rgba(218, 218, 218, 1);
}
.order_list .order_item .order_sn p {
  float: left;
}
.order_list .order_item .order_status {
  float: left;
  color: #aa2832;
  font-size: 24px;
  padding-left: 24px;
}
.order_list .order_item .count_down {
  float: right;
  text-align: right;
  display: block;
  /* width: 100%; */
  font-size: 20px;
  color: rgba(170, 40, 50, 1);
  padding-top: 8px;
  padding-right: 30px;
}
.order_list .order_item .shop_detail {
  width: 100%;
  padding: 24px 0 30px;
  border-bottom: solid 1px #f2f2f2;
  overflow: hidden;
}
.order_list .order_item .shop_detail .detail {
  float: left;
}
.order_list .order_item .shop_detail .detail .image {
  float: left;
  width: 140px;
  height: 140px;
  margin-right: 42px;
  position: relative;
}
.order_list .order_item .shop_detail .detail .image.active {
  margin-right: 14px;
}
.order_list .order_item .shop_detail .detail .image img {
  float: left;
  width: 140px;
  height: 140px;
}
.order_list .order_item .shop_detail .detail .image div {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 24px;
  color: rgba(255, 255, 255, 1);
  background: rgba(180, 39, 45, 1);
  position: absolute;
  left: 0;
  bottom: 0;
}
.order_list .order_item .shop_detail .detail .right {
  float: left;
  width: 390px;
}
.order_list .order_item .shop_detail .detail .right .box .text_1 {
  color: #333;
  font-size: 28px;
  line-height: 36px;
  padding: 8px 0 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  .abroad,
  .autark {
    float: left;
    width: 76px;
    height: 38px;
    line-height: 34px;
    text-align: center;
    font-size: 24px;
    border-radius: 6px;
    font-weight: 400;
    margin-right: 6px;
  }
  // 海外
  .abroad {
    border: 1px solid #E33F36; /* no*/
    color: #E33F36;
  }
  // 自营
  .autark {
    background: #E33F36;
    border: 1px solid #E33F36; /* no*/
    color: rgba(255, 255, 255, 1);
  }
}
.order_list .order_item .shop_detail .detail .right .box .text_2 {
  color: #666;
  font-size: 22px;
  line-height: 26px;
}
.order_list .order_item .shop_detail .detail .status {
  float: right;
  color: #aa2832;
  font-size: 24px;
  line-height: 140px;
  padding-right: 30px;
}
.order_list .total {
  float: left;
  color: #333;
  font-size: 28px;
  padding: 36px 0 38px;
}
.order_list .button_count {
  float: right;
  padding: 16px 0;
}
.order_list .order_item .button {
  /* float: right; */
  overflow: hidden;
}
/deep/ .van-button {
  float: right;
  margin-right: 30px;
}
.order_list .order_item .custom {
  height: 68px;
  font-size: 28px;
  line-height: 64px;
  padding: 0 20px;
  border-width: 1px; /* no*/
}
.order_list .order_item .customs {
  font-size: 28px;
  height: 28px;
  line-height: 1;
  padding: 0;
  border: none;
}
.customborderred{
  height: 68px;
  font-size: 28px;
  line-height: 64px;
  padding: 0 20px;
  border-width: 1px; /* no*/
  border-color: #aa2832;
  color: #aa2832;
}
/deep/.custom-image .van-empty__image {
    width: 317px;
    height: 257px;
  }
/deep/ .van-pull-refresh__head {
  font-size: 27px ;
}
/deep/ .van-pull-refresh__head{
  font-size: 27px ;
}
/deep/ .van-empty__description{
  font-size: 27px;
}
.ordermartop{
  // margin-top: 10px;
}
/deep/.van-list__finished-text{
  font-size: 26px;
}
</style>
